import PinchZoomPan from "./PinchZoomPan";

export default PinchZoomPan
